import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/Main',
    name: 'Main',
    component: () => import(/* webpackChunkName: "about" */ '../views/Main.vue'),
    children:[
      {
        path: '/Home',
        name: 'Home',
        component:  ()=>import('@/views/Home'),
        meta:{
          title: '工作台',
          isTab: true,
          close: false,
          keepAlive: false
        }
      },
      {
        path: '/Register',
        name: 'Register',
        component:  ()=>import('@/views/Register'),
        meta:{
          title: '挂号',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/Clinic',
        name: 'Clinic',
        component:  ()=>import('@/views/Clinic'),
        meta:{
          title: '门诊',
          isTab: true,
          close: true,
          keepAlive: false
        }
      },
      {
        path: '/Case',
        name: 'Case',
        component:  ()=>import('@/views/Case.vue'),
        meta:{
          title: '病历查询',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/CaseMain',
        name: 'CaseMain',
        component:  ()=>import('@/views/Case/CaseMain.vue'),
        meta:{
          title: '病历详情',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/Document',
        name: 'Document',
        component:  ()=>import('@/views/Document.vue'),
        meta:{
          title: '档案查询',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/Inpatient',
        name: 'Inpatient',
        component:  ()=>import('@/views/Inpatient.vue'),
        meta:{
          title: '住院',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/TaskAll',
        name: 'TaskAll',
        component:  ()=>import('@/views/TaskAll.vue'),
        meta:{
          title: '所有任务',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/DocDetail',
        name: 'DocDetail',
        component:  ()=>import('@/views/Doc/DocDetail.vue'),
        meta:{
          title: '档案详情',
          isTab: true,
          close: true,
          keepAlive: false
        }
      },
      {
        path: '/SettleWaitPay',
        name: 'SettleWaitPay',
        component:  ()=>import('@/views/Settle/SettleWaitPay.vue'),
        meta:{
          title: '待支付',
          isTab: true,
          close: true,
          keepAlive: false
        }
      },
      {
        path: '/SettleOrder',
        name: 'SettleOrder',
        component:  ()=>import('@/views/Settle/SettleOrder.vue'),
        meta:{
          title: '支付查询',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/SettleStat',
        name: 'SettleStat',
        component:  ()=>import('@/views/Settle/SettleStat.vue'),
        meta:{
          title: '支付统计',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/System',
        name: 'System',
        component:  ()=>import('@/views/System/SysMain.vue'),
        meta:{
          title: '系统',
          isTab: true,
          close: true,
          keepAlive: true
        }
      },
      {
        path: '/Remind',
        name: 'Remind',
        component:  ()=>import('@/views/Remind.vue'),
        meta:{
          title: '提醒',
          isTab: true,
          close: true,
          keepAlive: false
        }
      }
    ]
  },
  {
    path: '/PrintCase',
    name: 'PrintCase',
    component: () => import(/* webpackChunkName: "about" */ '../views/Print/PrintCase.vue'),
  },
  {
    path: '/PrintOrder',
    name: 'PrintOrder',
    component: () => import(/* webpackChunkName: "about" */ '../views/Print/PrintOrder.vue'),
  },
  {
    path: '/PrintBill',
    name: 'PrintBill',
    component: () => import(/* webpackChunkName: "about" */ '../views/Print/PrintBill.vue'),
  },
  {
    path: '/PrintDoc',
    name: 'PrintDoc',
    component: () => import(/* webpackChunkName: "about" */ '../views/Print/PrintDoc.vue'),
  },
  {
    path: '/caseOverview',
    name: 'caseOverview',
    component: () => import(/* webpackChunkName: "about" */ '../views/Case/Overview.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
